export function isPatternMatch(str, arr, warnKey) {
    return arr.some((item) => {
        if (item instanceof RegExp) {
            return item.test(str);
        }
        else if (typeof item === 'string') {
            item = item.toLowerCase();
            return item.includes(str.toLowerCase());
        }
        if (warnKey) {
            console.warn(`Coralogix Browser SDK - ${warnKey} must be from type string | Regex`);
        }
        return false;
    });
}
